import { getUserData } from '@/core/auth/utils'
import { $themeConfig } from '@themeConfig'

const naumenWs = $themeConfig.app.naumenWs || 'ws://localhost:9000'

export default {
    SET_SOCKET(state) {
        const { user } = getUserData()
        try {
            state.socket = new WebSocket(
                naumenWs,
                'nauphone-softphone-protocol'
            )
        } catch (e) {
            console.error(e)
        }
        state.socket.onmessage = message => {
            this.dispatch('naumen/addMessage', message.data)
        }
        state.socket.onopen = () => {
            const t = setInterval(function () {
                if (state.socket.readyState !== 1) {
                    clearInterval(t)
                    return
                }
                state.socket.send('')
            }, 60 * 1000)

            state.socket.send(
                JSON.stringify({
                    rid: user.id,
                    name: 'setProtocolVersion',
                    protocolVersion: '13',
                })
            )
            state.socket.send(
                JSON.stringify({
                    rid: user.id,
                    name: 'getUserState',
                })
            )
            state.socket.send(
                JSON.stringify({
                    rid: user.id,
                    name: 'getCurrentCall',
                })
            )
        }

        state.socket.onclose = () => {
            this.commit('naumen/CLEAR_NAUMEN_STATE')
            this.commit('naumen/SET_USER', { state: 'disabled' })
            this.dispatch('sessions/setStatus', 'disabled')
            this.dispatch('sessions/setChannel', '')
        }
        state.socket.onerror = () => {
            console.error('NAUMEN: Ошибка сокета')
        }
    },

    CHANGE_STATUS(state, newState) {
        const { user } = getUserData()
        if (state.socket && state.socket.readyState === state.socket.OPEN) {
            state.socket.send(
                JSON.stringify({
                    rid: user.id,
                    name: 'setUserState',
                    state: newState,
                })
            )
        }
    },

    SET_GUEST(state, guest) {
        if (!guest) state.guest = null
        else Object.assign(state.guest, guest)
    },
    // Повесить трубку
    HANGUP(state) {
        if (state.call) {
            const { user } = getUserData()
            state.socket.send(
                JSON.stringify({
                    rid: user.id,
                    name: 'hangup',
                    id: state.call.id,
                })
            )
        }
        state.endCall = true
    },
    ANSWER(state) {
        if (state.call) {
            const { user } = getUserData()
            state.socket.send(
                JSON.stringify({
                    rid: user.id,
                    name: 'answer',
                    id: state.call.id,
                })
            )
        }
    },
    MAKE_CALL(state, { url }) {
        const { user } = getUserData()
        state.socket.send(
            JSON.stringify({
                rid: user.id,
                name: 'makeCall',
                url,
            })
        )
    },
    SET_NOT_AVAILABLE(state, val) {
        state.notAvailable = val
    },

    CLEAR_NAUMEN_STATE(state) {
        state.call = null
        state.notAvailable = false
        state.guest = {
            id: '',
            first_name: 'Новый гость',
            is_vip: false,
            is_blacklisted: false,
            contacts: [],
        }
    },
    SET_GUEST_MODAL(state, b) {
        state.isGuestModalOpen = b
    },
    SET_LAST_CALL(state, call) {
        state.lastCall = call
    },
    SET_USER(state, call) {
        state.user = call
    },
    SET_USER_STATE(state, userState) {
        state.user.state = userState
    },
    SET_CALL(state, call) {
        state.call = call
    },
    SET_END_CALL_INDICATOR(state, b) {
        state.endCall = b
    },
}
